module.exports = __webpack_public_path__ + "static/media/Autonomia-APRENDIZAJE(B).31638fc3.svg";